import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const CROP_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CROP,
  false // No tenant ID in the base URL
);

export const getCropList = tenant =>
  apiClient.get(`${CROP_BASE}/list?is_crop_calendar=true`);

export const cropItemApi = {
  cropItemForm: () => apiClient.get(`${CROP_BASE}/form`),

  editCropItemForm: Id =>
    apiClient.get(`${CROP_BASE}/form?is_edit=true&crop_id=${Id}`),

  createCropItem: combinedData => apiClient.post(`${CROP_BASE}`, combinedData),

  updateCropItem: (crop_id, combinedData) =>
    apiClient.put(`${CROP_BASE}/${crop_id}`, combinedData)
};
